// @flow
import React from 'react';

type Props = {
    count: number
};

export default function Badge({ count }: Props) {
    const displayCount = count > 99 ? '99+' : `${count}`;

    return (
        <div className="badge">
            <p className="badge-text">{displayCount}</p>
        </div>
    );
}
